import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAcademicYear as apiDelete } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAcademicYear() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAcademicYear, isPending: isDelete } = useMutation({
        mutationFn: (id) => apiDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAcademicYear, isDelete };
}
